/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, FormGroup, Row } from 'reactstrap';
import Parse from 'parse';
import classNames from 'classnames';
import FontAwesome from 'react-fontawesome';
import withStyles from 'isomorphic-style-loader/withStyles';

import FAStyles from 'styles/global/font-awesome.css';
import FloatingLabel from 'components/FloatingLabel';
import history from 'core/history';
import { SuccessAlert, ErrorAlert } from 'helpers/alert';
import handleParseError from 'helpers/handleParseError';

import s from './ForgotPassword.scss';

class ForgotPassword extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { email: '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name } = event.target;
    const newState = {};
    newState[name] = event.target.value;
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.email === '') {
      ErrorAlert('Please complete the form');
      return;
    }
    Parse.User.requestPasswordReset(this.state.email)
      .then(() => {
        SuccessAlert(
          'Your password has successfully been reset.  Please check your email.',
        );
        history.push('/');
      })
      .catch(
        handleParseError(error => {
          ErrorAlert(error.message);
        }),
      );
  }

  /* eslint-disable css-modules/no-undef-class */
  render() {
    return (
      <div className={classNames([s.root, 'jumbotron', 'text-center'])}>
        <h1>{this.props.title}?</h1>
        <div className={s.container}>
          <Row className="justify-content-center">
            <Col xs={4}>
              <Form onSubmit={this.handleSubmit} method="post">
                <FormGroup>
                  <Row>
                    <Col sm={12}>
                      <Col sm={12}>
                        <FloatingLabel
                          placeholder="Email"
                          name="email"
                          id="email"
                          type="email"
                          value={this.state.email}
                          inputAdditionalStyles={{
                            border: 0,
                            borderTopRightRadius: '5px',
                            borderBottomRightRadius: '5px',
                          }}
                          labelAdditionalStyles={{ left: '18%' }}
                          labelFocusedAdditionalStyles={{ color: 'white' }}
                          onChange={this.handleChange}
                          errorMessage="Please enter a valid email."
                          isRequired
                        >
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <FontAwesome name="envelope" className="fa-fw" />
                            </div>
                          </div>
                        </FloatingLabel>
                      </Col>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm={12}>
                      <Col sm={12}>
                        <Button
                          type="submit"
                          className="btn-primary-dark"
                          block
                        >
                          Reset
                        </Button>
                      </Col>
                    </Col>
                  </Row>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withStyles(FAStyles, s)(ForgotPassword);
